
import Microscope from "../../../assets/outline/Microscope.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MicroscopeIcon({ className, dataTestid = "MicroscopeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Microscope data-testid={dataTestid} className={classes} {...rest} />
  );
}
